<template>
  <div class="app-container">
    <banner></banner>
    <div class="content-consult">
      <div class="consult-left">
        <div
          class="consult-list"
          v-for="item in companyList"
          :key="item.id"
          @click="getyard(item.id)"
          :class="{ active: activeId === item.id }"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="consult-right-container">
        <div class="consult-right">
          <img 
            class="qr-code"
            :src="yard || (companyList[0]?.wechat_qr_code)"
            alt="QR Code"
          />
        </div>
        <p class="consult-text">扫码添加资管联盟官方工作人员的微信进行联系</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getService } from "@/api/api";
import banner from "@/views/layout/components/banner.vue";

export default {
  components: { banner },
  data() {
    return {
      companyList: [],
      yard: "",
      activeId: null,
    };
  },
  methods: {
    async getService() {
      try {
        const res = await getService();
        this.companyList = res.results;
        // 设置第一项为默认选中
        if (this.companyList.length > 0) {
          const firstItem = this.companyList[0];
          this.yard = firstItem.wechat_qr_code;
          this.activeId = firstItem.id;
        }
      } catch (error) {
        console.error("获取客服列表失败:", error);
      }
    },
    getyard(id) {
      this.activeId = id;
      const selected = this.companyList.find((item) => item.id === id);
      if (selected) {
        this.yard = selected.wechat_qr_code;
      }
    },
  },
  mounted() {
    this.getService();
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  padding: 16px;
}

.content-consult {
  max-width: 720px;
  background: #ffffff;
  border-radius: 8px;
  margin: 38px auto;
  display: flex;
  padding: 16px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.consult-left {
  background: #f8f7fb;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px;
}

.consult-list {
  width: 180px;
  height: 60px;
  background: #f8f7fb;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  text-align: center;
  font-size: 16px;
  color: #7e7f83;
  line-height: 60px;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;

  &.active {
    background: #55a5fa;
    color: #ffffff;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  }

  &:hover {
    background: #e3f2ff;
  }
}

.consult-right-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 44px;
}

.consult-right {
 
  background: #f8f7fb;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.qr-code {
 
  width: 280px;
  height: 310px;
  object-fit: cover;
  border-radius: 4px;
}

.consult-text {
  margin-top: 12px;
  font-size: 16px;
  color: #7e7f83;
  text-align: center;
}
</style>
